import { render } from "./PainelBase.vue?vue&type=template&id=891a2b88&scoped=true"
import script from "./PainelBase.vue?vue&type=script&lang=js"
export * from "./PainelBase.vue?vue&type=script&lang=js"

import "./PainelBase.vue?vue&type=style&index=0&id=891a2b88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-891a2b88"]])

export default __exports__